import anne_karenina from './img/anne_karenina.jpeg'
import beloved from './img/beloved.jpeg'
import to_the_lighthouse from './img/to_the_lighthouse.jpeg'
import catch22 from './img/catch22.jpeg'
import don_quixote from './img/don_quixote.jpeg'
import emma from './img/emma.jpeg'
import great_expections from './img/great_expections.jpeg'
import gullivers_travels from './img/gullivers_travels.jpeg'
import invisible_man from './img/invisible_man.jpeg'
import jane_eyre from './img/jane_eyre.jpeg'
import little_women from './img/little_women.jpeg'
import lolita from './img/lolita.jpeg'
import madame_bovary from './img/madame_bovary.jpeg'
import middlemarch from './img/middlemarch.jpg'
import midnights_children from './img/midnights_children.jpeg'
import mrs_dalloway from './img/mrs_dalloway.jpg'
import pride_and_prejudice from './img/pride_and_prejudice.jpeg'
import slaughter_five from './img/slaughter_five.jpeg'
import the_great_gatsby from './img/the_great_gatsby.jpeg'
import the_rainbow from './img/the_rainbow.jpeg'
import the_scarlet_letter from './img/the_scarlet_letter.jpeg'
import the_trial from './img/the_trial.jpg'
import ulysses from './img/ulysses.jpeg'
import wuthering_heights from './img/wuthering_heights.jpeg'


export const NBookItems = [
  {
    id:1401,
    title:"To The Lighthouse",
    image: to_the_lighthouse,
    price:199,
    
  },
  {
    id:1402,
    title:"Anne Karenina",
    image: anne_karenina,
    price:399,
    
  },
  {
    id:1403,
    title:"Beloved",
    image: beloved,
    price:699,
    
  },
  {
    id:1404,
    title:"Catch22",
    image: catch22,
    price:399,
    
  },
  {
    id:1405,
    title:"Don Quixote",
    image: don_quixote,
    price:229,
    
  },
  {
    id:1406,
    title:"Emma",
    image: emma,
    price:599,
    
  },
  {
    id:1407,
    title:"Great Expections",
    image: great_expections,
    price:499,
    
  },
  {
    id:1408,
    title:"Gulliver's Travels",
    image: gullivers_travels,
    price:899,
    
  },
  {
    id:1409,
    title:"Invisible Man",
    image: invisible_man,
    price:299,
    
  },
  {
    id:1410,
    title:"Jane Eyre",
    image: jane_eyre,
    price:299,
    
  },
  {
    id:1411,
    title:"Little Women",
    image: little_women,
    price:999,
    
  },
  {
    id:1412,
    title:"Lolita",
    image: lolita,
    price:499,
    
  },
  {
    id:1413,
    price:199,
    title: "Madame Bovary",
    image: madame_bovary,
    
  },
  {
    id:1414,
    price:399,
    title: "Middlemarch",
    image: middlemarch,
   
  },
  {id:1415,
    price:359,
    title: "Midnight's Children",
    image: midnights_children,
    
  },
  {
    id:1416,
    price:329,
    title: "Mrs Dalloway",
    image: mrs_dalloway,
    
  },
  {
    id:1417,
    price:199,
    title: "Pride And Prejudice",
    image: pride_and_prejudice,
    
  },
  {
    id:1418,
    price:599,
    title: "Slaughter five",
    image: slaughter_five,
    
  },
  {
    id:1419,
    price:169,
    title: "The Great Gatsby",
    image: the_great_gatsby,
    
  },
  {
    id:1420,
    price:379,
    title: "The Rainbow",
    image: the_rainbow,
    
  },
  {
    id:1421,
    price:299,
    title: "The Scarlet Letter",
    image: the_scarlet_letter,
    
  },
  {
    id:1422,
    price:399,
    title: "The Trial",
    image: the_trial,
    
  },
  {
    id:1423,
    price:699,
    title: "Ulysses",
    image: ulysses,
    
  },
  {
    id:1424,
    price:799,
    title: "Wuthering Heights",
    image: wuthering_heights,
    
  },
  
];